/* Which no-login fixture this page load is, if any. Only ever on localhost:
   on nycsuite.io this is always "". Shared by main.jsx (which picks the root)
   and any fixture that has to install stand-ins at module scope, because
   main.jsx imports every fixture on every page load, production included. A
   fixture's module-level side effect that is not gated on this runs for real
   users. That happened: from 2026-09-06 to 2026-09-30 the CRM fixture replaced
   the campaignSend client and seeded the interactions and open-items caches
   on nycsuite.io, so "Send me a test" reported success without calling the
   server. */
export function localE2EMode() {
  if (typeof window === "undefined") return "";
  const host = window.location.hostname;
  const isLocal = host === "localhost" || host === "127.0.0.1";
  if (!isLocal) return "";
  return new URLSearchParams(window.location.search).get("e2e") || "";
}
